class NewRelicService {
	constructor() {
		this.isInitialized = false;
		this.config = {};
	}

	initialize(config = {}) {
		if (this.isInitialized) {
			console.warn("New Relic is already initialized");
			return;
		}

		this.config = { ...this.config, ...config };

		window.NREUM || (window.NREUM = {});
		window.NREUM.init = {
			distributed_tracing: { enabled: true },
			privacy: { cookies_enabled: true },
			ajax: { deny_list: ["bam.nr-data.net"] },
		};

		window.NREUM.loader_config = {
			accountID: this.config.accountID,
			trustKey: this.config.trustKey,
			agentID: this.config.agentID,
			licenseKey: this.config.licenseKey,
			applicationID: this.config.applicationID,
		};

		window.NREUM.info = {
			beacon: "bam.nr-data.net",
			errorBeacon: "bam.nr-data.net",
			licenseKey: this.config.licenseKey,
			applicationID: this.config.applicationID,
			sa: 1,
		};

		this.loadScript();

		this.isInitialized = true;
		console.log("New Relic initialized successfully");
	}

	loadScript() {
		const script = document.createElement("script");
		script.type = "text/javascript";
		script.src = "https://js-agent.newrelic.com/nr-loader-spa-current.min.js";
		script.async = true;

		script.onload = () => {
			console.log("New Relic script loaded successfully");
		};

		script.onerror = (error) => {
			console.error("Failed to load New Relic script:", error);
		};

		document.head.appendChild(script);
	}

	updateConfig(newConfig) {
		this.config = { ...this.config, ...newConfig };

		if (window.NREUM) {
			window.NREUM.loader_config = {
				accountID: this.config.accountID,
				trustKey: this.config.trustKey,
				agentID: this.config.agentID,
				licenseKey: this.config.licenseKey,
				applicationID: this.config.applicationID,
			};

			window.NREUM.info = {
				beacon: "bam.nr-data.net",
				errorBeacon: "bam.nr-data.net",
				licenseKey: this.config.licenseKey,
				applicationID: this.config.applicationID,
				sa: 1,
			};

			window.NREUM.init = {
				distributed_tracing: { enabled: true },
				privacy: { cookies_enabled: true },
				ajax: { deny_list: ["bam.nr-data.net"] },
			};
		}
	}

	getConfig() {
		return { ...this.config };
	}

	isReady() {
		return this.isInitialized && !!window.NREUM;
	}
}

const newRelicService = new NewRelicService();

export default newRelicService;
